import { createLinearChartReducer } from 'features/dashboard/redux/createLinearChartReducer';

export const ordersGraph = createLinearChartReducer('ordersGraph', '/orders/orders-graph/');
